<template>
    <div class="alm-items-name-wrapper">
        <span class="items-value-span">{{ value }}</span>
        <div class="alm-items-subdetails-wrapper">
            <span class="items-subdetails-value-span">{{ `Source: ${sourceTenant}` }}</span>
            <span class="items-divider"></span>
            <span class="items-subdetails-value-span">{{ `Last deployed: ${lastDeployed}` }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { FormatDateTime } from "@/utils/Utils";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
    computed: {
        value() {
            return this.params?.value;
        },
        sourceTenant() {
            return this.params?.data?.source || "";
        },
        lastDeployed() {
            return this.params?.data?.lastDeployed ? FormatDateTime(this.params.data.lastDeployed) : this.localizer.Localize('LandscapeManagement_Never_Deployed_Text');
        },
    },
});
</script>

<style>
.alm-items-name-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
}

.alm-items-name-wrapper .items-value-span {
    font-size: 14px;
    line-height: 17px;
    padding-right: 16px;
    font-weight: 600;
    text-transform: capitalize;
}

.alm-items-subdetails-wrapper {
    display: flex;
    flex-direction: row;
    gap: 8px;
    line-height: normal;
    padding: 8px 0;
    align-items: center;
}

.alm-items-subdetails-wrapper .items-subdetails-value-span {
    font-size: 12px;
    color: var(--accent-color5);
    line-height: 13px;
}

.alm-items-subdetails-wrapper .items-divider {
    display: inline-block;
    background: #E6EBF8;
    width: 1px;
    height: 24px;
    vertical-align: middle;
}
</style>
